// extracted by mini-css-extract-plugin
module.exports = {"overlay":"NotificationOverlay_overlay__bc84l"};